import { getDatesListFromCountry } from "@/entities/new-order/utils";
import { TNewOrderCountry } from "@/entities/new-order";

export const dateListsCheck = (
  country: TNewOrderCountry,
  newDateArray: string[],
): boolean => {
  const oldDateList = getDatesListFromCountry(country);
  const newDateList = newDateArray;

  if (oldDateList.length === 0) {
    return true;
  }

  if (oldDateList.length !== newDateList.length) {
    return false;
  }

  return oldDateList.every((date, index) => date === newDateList[index]);
};
